module.exports = __webpack_public_path__ + "img/bot.8e30595f.png";